import { FormEvent, RefObject } from 'react'
import cx from 'classnames'

import { ReactComponent as ClearInputIcon } from '../icons/cross.svg'
import Styles from '../Prompt.module.scss'

import { HTMLInputEvent } from 'types'
import { Search } from 'blaze-ui/icons'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { Send2 } from 'blaze-ui/icons/16'

export interface Props {
  query: string
  placeholder: string
  inputRef?: RefObject<HTMLInputElement>
  onSubmit: (event?: KeyboardEvent | FormEvent) => void
  onChange: (event: HTMLInputEvent) => void
  clearQuery: () => void
  showSearchAffordance?: boolean
  showIcon?: boolean
}

export const SearchForm = ({
  query,
  placeholder,
  onSubmit,
  onChange,
  clearQuery,
  inputRef,
  showSearchAffordance = false,
  showIcon = false,
}: Props) => {
  const { isMobile } = useResponsiveDesign()

  return (
    <form onSubmit={onSubmit} className={Styles.headerWrapper}>
      <div className={Styles.searchFormWrapper}>
        {showIcon && (
          <div className={Styles.searchIcon}>
            <Search />
          </div>
        )}
        <input
          autoFocus
          ref={inputRef}
          id="mediaUploadSearchForm"
          type="text"
          className={Styles.searchInput}
          value={query}
          onChange={onChange}
          placeholder={placeholder}
          autoComplete="off"
          aria-label="Search Form Input"
        />

        {showSearchAffordance && !isMobile && (
          <div
            aria-hidden="true"
            className={cx(Styles.searchAffordance, { [Styles.searchButtonHidden]: !query })}
            onClick={onSubmit}
          >
            <span>Search</span>
            <span className={Styles.enterKey}>↵</span>
          </div>
        )}
        <div className={cx(Styles.clearButton, { [Styles.clearButtonVisible]: !!query })} onClick={clearQuery}>
          <ClearInputIcon />
        </div>
      </div>

      {isMobile && <IconButton isDisabled={!query} icon={Send2} size="lg" onPress={() => onSubmit()} />}
    </form>
  )
}
